import { useEffect, useState } from 'react'
import multicall from 'utils/multicall'
import piBridgeAirdropAbi from 'config/abi/piBridgeAirdropAbi.json'
import BigNumber from 'bignumber.js'
import { getAddress } from 'utils/addressHelpers'
import contracts from 'config/constants/contracts'
import token from 'config/constants/tokens'
import useRefresh from 'hooks/useRefresh'
import whitelistUser from './whitelistUser.json'

export const CheckWhiteList = (account, isRefesh) => {
  const [isWhiteList, setIsWhiteList] = useState(false)
  useEffect(() => {
    const getWhiteList = async () => {
      try {
        const call = [
          {
            address: getAddress(contracts.piNFTS),
            name: 'hasRole',
            params: ['0xdc72ed553f2544c34465af23b847953efeb813428162d767f9ba5f4013be6760', account],
          },
        ]
        
        const [userIsWhiteList] = await multicall(piBridgeAirdropAbi, call)

        setIsWhiteList(userIsWhiteList[0])
      } catch (error) {
        console.log(error)
      }
    }
    if (account) {
      getWhiteList()
    }
  }, [account, isRefesh ])
  return { isWhiteList }
}



export const CheckUserMint = () => {
  const [dataUser, setDataUser] = useState({
    startTimeMint: 0,
    whitelistCount: 0,
    whitelistMintedCount: 0,
    leftNfts: 0,
  })
  const { fastRefresh } = useRefresh()

  useEffect(() => {
    const fetDataUser = async () => {
      try {
        
        const calls = [
          {
            address: getAddress(contracts.piNFTS),
            name: 'startTime',
            params: []
          },
          {
            address: getAddress(contracts.piNFTS),
            name: 'whitelistCount',
            params: []
          },
          {
            address: getAddress(contracts.piNFTS),
            name: 'whitelistMintedCount',
            params: []
          }
        ]
        const [startTime, whitelistCount, whitelistMintedCount] = await multicall(piBridgeAirdropAbi, calls);
        setDataUser({
          startTimeMint: Number(new BigNumber(startTime).toJSON()),
          whitelistCount:  Number(new BigNumber(whitelistCount).toJSON()),
          whitelistMintedCount: Number(new BigNumber(whitelistMintedCount).toJSON()),
          leftNfts: Number(new BigNumber(whitelistCount).toJSON()) - Number(new BigNumber(whitelistMintedCount).toJSON())
          
        })
        
      } catch (error) {
        console.log(error);
        
      }
    }
    fetDataUser();
  }, [fastRefresh])
  return {dataUser}
}

export const CheckWhiteListTable = () => {
  const [isWhiteListTable, setIsWhiteListTable] = useState([])
  useEffect(() => {
    const getWhiteList = async () => {
      try {
        const call = [];
        const callMint = [];

        for (let i = 0; i < whitelistUser.length; i++) {
          call.push(
            {
              address: getAddress(contracts.piNFTS),
              name: 'hasRole',
              params: ['0xdc72ed553f2544c34465af23b847953efeb813428162d767f9ba5f4013be6760', whitelistUser[i]],
            }
          )
          callMint.push(
            {
              address: getAddress(contracts.piNFTS),
              name: 'userMintedMap',
              params: [whitelistUser[i]],
            }
          )
        }
        
        // const userIsWhiteList = await multicall(piBridgeAirdropAbi, call)
        // const userisMinted = await multicall(piBridgeAirdropAbi, callMint)

        const listText = []
        for (let i = 0; i < whitelistUser.length; i++) {
          listText.push(
            {
              address: whitelistUser[i],
              available: true,
              minted: false
            }
          )
        }
        
        setIsWhiteListTable(listText)
      } catch (error) {
        console.log(error)
      }
    }
    getWhiteList()
  }, [])
  return { isWhiteListTable }
}

export const CheckWhiteListV2 = (userList: any[]) => {
  const [whiteListTable, setWhiteListTable] = useState([])
  useEffect(() => {
    const getWhiteList = async () => {
      try {
        const call = [];
        const callMint = [];

        for (let i = 0; i < userList.length; i++) {
          call.push(
            {
              address: getAddress(contracts.piNFTS),
              name: 'hasRole',
              params: ['0xdc72ed553f2544c34465af23b847953efeb813428162d767f9ba5f4013be6760', userList[i].address],
            }
          )
          callMint.push(
            {
              address: getAddress(contracts.piNFTS),
              name: 'userMintedMap',
              params: [userList[i].address],
            }
          )
        }
        
        const userIsWhiteList = await multicall(piBridgeAirdropAbi, call)
        const userisMinted = await multicall(piBridgeAirdropAbi, callMint)

        const listText = []
        for (let i = 0; i < userList.length; i++) {
          listText.push(
            {
              address: userList[i].address,
              available: userIsWhiteList[i][0],
              minted: userisMinted[i][0]
            }
          )
        }
        
        setWhiteListTable(listText)
      } catch (error) {
        console.log(error)
      }
    }
    getWhiteList()
  }, [userList])
  return { whiteListTable }
}


export const CheckUserMintedMap = (account) => {
  const [isUserMintedMap, setIsUserMintedMap] = useState(false)
  const { fastRefresh } = useRefresh()

  useEffect(() => {
    const getUserMintedMap = async () => {
      try {
        const call = [
          {
            address: getAddress(contracts.piNFTS),
            name: 'userMintedMap',
            params: [account]
          },
        ]
        const [userMintedMap] = await multicall(piBridgeAirdropAbi, call);
        setIsUserMintedMap(userMintedMap[0]);
        
      } catch (error) {
        console.log(error);
      }
    }
    if (account) {
      getUserMintedMap();
    }
  }, [account, fastRefresh])

  return { isUserMintedMap }
}